import { render, staticRenderFns } from "./AttachmentsView.vue?vue&type=template&id=1e1ab61d&scoped=true&"
import script from "./AttachmentsView.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsView.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsView.vue?vue&type=style&index=0&id=1e1ab61d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1ab61d",
  null
  
)

export default component.exports